import { apiClient } from './client';

const BASE = '/api/reports/faicon';
const ALL = { sort_by: 'name', sort_type: 'asc', limit: 1000 };

/** FAICON catalog, read through the backend proxy. */
export const faiconApi = {
  getAllEvents: async () => {
    const response = await apiClient.get(`${BASE}/events`, { params: ALL });
    return response.data;
  },

  getSessionsByEvent: async (eventId) => {
    const response = await apiClient.get(`${BASE}/events/${eventId}/sessions`, { params: ALL });
    return response.data;
  },
};
